<template lang="html">
  <div @mouseleave="show = false" v-click-outside="onClickOutside" class="picker-wrapper" :class="{blackDiv:blackDiv}">
    <div class="picker">
      <div @click="show = !show" class="height-wrapper">
        <div class="picker-flag">
          <!-- <flag :squared="false" :iso="$i18n.locale" /> -->
          <img class="flag" 
          :src="
          production ? 
          path_prefix.slice(0, -1).concat(getFlag($i18n.locale)): 
            getFlag($i18n.locale)"
          alt="">
        </div>
        <div class="picker-title">
          {{$i18n.locale}}
        </div>
        <img class="dropdown-arrow" 
        :src="
          production ? 
          path_prefix.slice(0, -1).concat(getArrow):
          getArrow" 
         alt="dropdown arrow">
      </div>
    </div>
    <div v-if="this.show" class="dropdown-wrapper">
      <div class="dropdown">
        <div @click="changeLocale(locale)" v-for="locale in $i18n.availableLocales" :key="locale" class="locale-option">
          <div class="picker-flag">
            <!-- <flag :squared="false" :iso="getFlag(locale)" /> -->
            <img class="flag" 
            :src="
            production ? 
            path_prefix.slice(0, -1).concat(getFlag(locale)): 
            getFlag(locale)" alt="">
          </div>
          <div class="picker-title">
            {{locale}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import de from '../assets/images/icons/de.svg'
export default {
  name: 'LocalePicker',
  mounted () {
    this.production = process.env.NODE_ENV === 'production'
    this.path_prefix = window.__blog_path_prefix
  },
  props: {
    blackDiv: {
      type: Boolean,
      default: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      show: false,
      selected: false,
      production: false,
      path_prefix: null,
    }
  },
  computed: {
    getFlag () {
      return locale => {
        switch (locale) {
          case 'sr':
            return require('../assets/images/icons/rs.svg')
          case 'en':
            return require('../assets/images/icons/gb.svg')
          case 'de':
            return de
          default:
            return require('../assets/images/icons/rs.svg')
        }
      }
    },
    getArrow() {
      return require('../assets/images/loginArrowGreenBack.svg')
    }
  },
  methods: {
    onClickOutside () {
      this.show = false
    },
    changeLocale (locale) {
      this.$i18n.locale = locale
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
.picker-wrapper {
    // background-color: var(--green-color);
  height: 100%;
  display: flex;
  position: relative;

  .flag {
    height: 19px;
    width: 26px;
    margin-right: 5px;
  }

  .dropdown-wrapper {
    //   background-color: var(--green-color);
    padding: 20px;
    padding-top: 40px;
    padding-right: 0px;
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 3;
  }
  .dropdown {
    background-color: var(--main-background-color);
    padding: 10px;
    right: 0px;
    top: 100%;
    border: 1px solid var(--border-color);
    box-shadow: 0px 0px 5px var(--border-color);
    border-radius: 5px;

    .locale-option {
      display: flex;
      align-items: center;
      cursor: pointer;

      .picker-title {
        // margin-top: 5px;
        margin-right: 0px;
         color: var(--text-soft-color);
      }
    }
    .locale-option:first-of-type{
      margin-bottom: 15px;
    }
    .locale-option:hover .picker-title {
            color: var(--green-color);
    //   color: $text-hover-color;
    }
  }
}
.picker {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .height-wrapper {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}
.picker-flag span {
  border-radius: 3px;
  margin-right: 5px;
}
.picker-title {
  margin-right: 5px;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 21px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  transition-duration: 0.2s;
  color: var(--header-text-color);
}
.picker:hover .picker-title {
//   color: $text-hover-color;
}
.small-nav-wrapper {
  .picker-wrapper {
    margin-bottom: 200px;
  }
  .dropdown-wrapper {
    padding: 0px;
    position: absolute;
    top: 50px;
    left: 0px;
    z-index: 3;
    width: 85px;
  }
  .dropdown-arrow {
    filter: brightness(5);
    max-width: 10px;
  }
  .height-wrapper .picker-title {
    color: var(--title-color);
  }
}
.picker-wrapper.blackDiv {
  margin-bottom: 0 !important;
  min-height: 120px !important;
  background-color: var(--header-background-color);
  color: var(--header-text-color);
  .dropdown-wrapper{
    top: 30px;
    left: 0px;
  }
   .dropdown {
    background-color: var(--header-background-color);

    padding: 0px;
    right: 0px;
    top: 10%;
    border: transparent;
    .picker-title{
      color: var(--header-text-color);
    }
   }

}
</style>
